/**
 * Defines a collection of AgentDevice objects.
 */
import _ from 'underscore';

import Backbone from 'backbone';
import AgentDevice from 'models/device/AgentDevice';

var AgentDevices = Backbone.Collection.extend({
    model: AgentDevice,

    url: function() {
        var url = '/device-service/deviceregistration/devices';
        if (!_.isUndefined(this.displayName)) {
            url += '/all/' + this.displayName;
        }
        return url;
    },

    backend: 'gcapi',

    parse: function(response) {
        if (response != null) {
            AgentDevices.cache = response;
        }
        return AgentDevices.cache;
    },

    fetch: function(options) {
        var useCache = true;
        if (options && typeof options.useCache != 'undefined') {
            useCache = options.useCache;
        }
        if (AgentDevices.cache == undefined || !useCache) {
            return Backbone.Collection.prototype.fetch.call(this, options);
        } else {
            this.add(AgentDevices.cache);
            options.success();
        }
    },

    /**
     * Removes those models where the predicate returns false.
     * @param predicate
     * @param silentFlag - if true will not notify event handlers of changes to the collection
     */
    filter: function(predicate, silentFlag) {
        if (typeof predicate === 'function') {
            var models = [];
            for (var i = 0; i < this.models.length; i++) {
                if (predicate(this.models[i])) {
                    models.push(this.models[i]);
                }
            }
            // don't want to send any events that we have changed the collection
            this.reset(models, { silent: silentFlag });
        }
    },

    hasDeviceWithCapability: function(capabilityKey) {
        return (
            this.find(function(device) {
                return device.get(capabilityKey);
            }) !== undefined
        );
    },

    // Returns an array of devices based on a capability
    getDevicesWithCapability: function(capabilityKey) {
        var capableDevices = [];

        for (var i = 0, length = this.length; i < length; i++) {
            if (this.models[i].get(capabilityKey)) {
                capableDevices.push(this.models[i]);
            }
        }

        return capableDevices;
    },

    getPrimaryWearableDevice: function() {
        let deviceArr = this.models.filter((device) => device.get('primaryActivityTrackerIndicator'));

        if (deviceArr && deviceArr.length > 0) {
            return deviceArr[0];
        }

        return null;
    },

    initialize: function(models, args) {
        this.cache = null;
        if (args) {
            this.displayName = args.displayName || null;
        }
    }
});

export default AgentDevices;
